(function () {
	'use strict';

	angular
	.module('core')
	.directive('autoComplete', autoComplete);

	autoComplete.$inject = ['$sce', '$timeout'];

	function autoComplete($sce, $timeout) {
		return {
			restrict: 'E',
			transclude: true,
			templateUrl: './templates/directives/auto-complete.html',
			scope:{
					'model':'=model',
					'lookup':'=lookup',
					'values':'=values'
			},
			link: function(vm, elem) {
				vm.suggestions = [];

				vm.search = function(event){
					switch(event.key){
						case 'Enter':
						vm.setValue(vm.model);
						$(event.target).blur();
						break;

						default:
						vm.suggestions = vm.lookup(event, vm.model);
						break;
					}
				}
				vm.setValue = function(value){
					if(vm.values.indexOf(value) < 0){
						vm.values.push(value);
					}
					vm.model = value;
				}

			}
		}
	}

	angular
	.module('core')
	.directive('inject', function(){
		return {
			link: function($scope, $element, $attrs, controller, $transclude) {
				if (!$transclude) {
					throw minErr('ngTransclude')('orphan', 'Illegal use of ngTransclude directive in the template! ' + 'No parent directive that requires a transclusion found. ' + 'Element: {0}', startingTag($element));
				}
				var innerScope = $scope.$new();
				$transclude(innerScope, function(clone) {
					$element.empty();
					$element.append(clone);
					$element.on('$destroy', function() {
						innerScope.$destroy();
					});
				});
			}
		};
	});
})();